import {LinkType} from "./_types";
import {MOUNTAINEER_ROUTE, OTHER_BACKPACKS_ROUTE} from "../../constants/ROUTES";
import {Trans} from "react-i18next";
import React from "react";

export const MOUNTAINEER_LINK: LinkType = {linkText: <Trans>MountaineerFoodsLink.Text</Trans>, linkRoute: MOUNTAINEER_ROUTE};
export const OTHER_BACKPACKS_LINK: LinkType = {linkText: <Trans>OtherBackpacksLink.Text</Trans>, linkRoute: OTHER_BACKPACKS_ROUTE};